import React from 'react';
import PropTypes from 'prop-types';
import withInit from 'WithInit';
import Banner from 'Banner';

const BuilderReactivationBanner = ({
  builderType,
  isCancelled,
}) => {
  const trackAndRedirect = () => {
    if (isCancelled) {
      window._track('Reactivate Banner', `${builderType} Builder`);
      window.location.assign('/my-account?skip_start_reactivation=1');
    } else {
      window._track('Upgrade Banner', `${builderType} Builder`);
      window.location.assign('/upgrade-freemium');
    }
  };

  return (
    <Banner isCloseable={false}>
      <div className="builder-reactivation-banner">
        <p className="free-downloads-text">
          Looks like you are out of free downloads, but not to worry!
        </p>
        <p className="discount-text">
          To download this document,
          {' '}
          <a className="upgrade" onClick={trackAndRedirect}>
            {isCancelled ? 'REACTIVATE' : 'UPGRADE'}
          </a>
          {' '}
          {isCancelled ? 'your' : 'to a'}
          {' '}
          paid plan today!
        </p>
      </div>
    </Banner>
  );
};

BuilderReactivationBanner.defaultProps = {
  isCancelled: false,
};

BuilderReactivationBanner.propTypes = {
  builderType: PropTypes.string.isRequired,
  isCancelled: PropTypes.bool,
};

export default withInit(BuilderReactivationBanner);




// WEBPACK FOOTER //
// ./src-react/ReactivationBanner/BuilderReactivationBanner.jsx